var nlsMessages = {
    "ja_JP": {
        "HISTORY" :"履歴",
        
        "ARTICLES" : "アーティクル",
        "BRAND" : "ブランド",
        "CATEGORY" : "カテゴリー",
        
        "ERR_RESOLVING_SKU" : "選択が不完全であるか、在庫がありません。 各属性に値を確実に指定するか、値の組み合わせを変えることをご考慮ください。",
        "QUANTITY_INPUT_ERROR" : "「数量」フィールドの値が無効です。 値が正の整数であることを確認してから、もう一度やり直してください",
        "QUANTITY_INPUTS_ERROR" : "「数量」フィールドの値が無効であるか、空です。 値が正の整数であることを確認してから、もう一度やり直してください",
        "WISHLIST_ADDED" : "アイテムは正常に買い物候補リストに追加されました。",
        "ERROR_CONTRACT_EXPIRED_GOTO_ORDER" : "いくつかのオーダー・アイテムの契約が使用不能になったため、選択したアイテムをショッピング・カートに追加できません。 オーダー・アイテムに適用する選択可能な契約を選択してください。",
        "MYACCOUNT_SAVEDORDERLIST_EMPTY_ADD_TO_REQ_FAIL" : "この保管オーダーは空であるため、要求リストにコピーできません。  1 つ以上のアイテムを保管オーダーに追加してください。",
        "SHOPCART_ADDED" : "アイテムは正常にショッピング・カートに追加されました。",
        "PRICE" : "価格:",
        "SKU" : "SKU:",
        "PQ_PURCHASE" : "購入:",
        "PQ_PRICE_X" : "{0} -",
        "PQ_PRICE_X_TO_Y" : "{0} から {1} -",
        "PQ_PRICE_X_OR_MORE" : "{0} 以上 -",
        
        "COMPARE_ITEM_EXISTS" : "比較ゾーンに追加しようとしている商品は既に存在します。",
        "COMPATE_MAX_ITEMS" : "比較できる商品は 4 つまでです。",
        "COMPAREZONE_ADDED" : "アイテムは正常に比較ゾーンに追加されました。",
        
        "GENERICERR_MAINTEXT" : "最後のご要求を処理中にストアは問題を検出しました。 もう一度やり直してください。 問題が続く場合は、{0} までお問い合わせください。",
        "GENERICERR_CONTACT_US" : "問い合わせ先",
        
        "MSC_ITEMS" : "{0} 個のアイテム",
        
        
        "DEFAULT_WISH_LIST_NAME" : "買い物候補リスト",
        "LIST_CREATED" : "買い物候補リストが正常に作成されました。",
        "LIST_EDITED" : "買い物候補リスト名が正常に変更されました。",
        "LIST_DELETED" : "買い物候補リストが正常に削除されました。",
        "ITEM_ADDED" : "アイテムが買い物候補リストに追加されました。",
        "ITEM_REMOVED" : "アイテムが買い物候補リストから除去されました。",
        "ERR_NAME_EMPTY" : "買い物候補リストの名前を入力してください。",
        "ERR_NAME_TOOLONG" : "買い物候補リストの名前が長すぎます。",
        "ERR_NAME_SHOPPING_LIST" : "「買い物候補リスト」という名前は、デフォルトの買い物候補リスト用に予約済みの名前です。 別の名前を選択してください。",
        "ERR_NAME_DUPLICATE" : "選択された名前の買い物候補リストは既に存在します。 別の名前を選択してください。",
        "INVALID_NAME_SHOPPING_LIST" : "買い物候補リスト名に無効な文字が含まれています。  英数字の名前を入力してください。",
        "WISHLIST_EMAIL_SENT" : "E メールが送信されました。",
        "WISHLIST_MISSINGNAME" : "「名前」フィールドをブランクにすることはできません。 「名前」フィールドに名前を入力し、やり直してください。",
        "WISHLIST_MISSINGEMAIL" : "「E メール・アドレス」フィールドをブランクにすることはできません。 買い物候補リストを送信する相手の E メール・アドレスを入力し、やり直してください。",
        "WISHLIST_INVALIDEMAILFORMAT" : "E メール・アドレス形式が無効です。",
        "WISHLIST_EMPTY" : "E メールを送信する前に、買い物候補リストを作成してください。",
        "WISHLIST_INVALIDSENDERNAME" : "「名前」フィールドに無効な文字が含まれています。 「名前」フィールドに名前を入力し、やり直してください。",
            
        
        "INV_STATUS_RETRIEVAL_ERROR" : "在庫状況の取得中にエラーが発生しました。 後でもう一度やり直してください。 問題が解決しない場合は、サイトの管理者に連絡してください。",
        "INV_ATTR_UNAVAILABLE" : "{0} - 入手不可",
        
        
        "CONFIGURATION" : "構成",
        
        
        "QC_UPDATE_SUCCESS" : "クイック・チェックアウト・プロファイルが正常に更新されました。",
        "MYACCOUNT_ACTION_PERFORMED" : "アクションが正常に実行されました。",
        
        
        
        "ITEM_COMPONENT_QUANTITY_NAME" : "{0} x {1}",
        
        
        "ORDER_LINE_STATUS_S" : "オーダー配送済み",
        "ORDER_LINE_STATUS_G" : "オーダー処理",
        "ORDER_LINE_STATUS_K" : "関連付けられた返品",
        "ORDER_LINE_STATUS_V" : "一部配送済み",
        "ORDER_LINE_STATUS_X" : "キャンセルされたオーダー",
        
        
        "ERROR_FACET_PRICE_INVALID" : "入力した価格の形式が無効です。",
        
        
        "ERROR_RecipientTooLong" : "「配送先」フィールドに入力した値が長すぎます。",
        "ERROR_FirstNameTooLong" : "「名」フィールドに入力した値が長すぎます。",
        "ERROR_LastNameTooLong" : "「姓」フィールドに入力した値が長すぎます。",
        "ERROR_MiddleNameTooLong" : "「ミドルネーム」フィールドに入力した値が長すぎます。",
        "ERROR_AddressTooLong" : "番地フィールドに入力した値が長すぎます。",
        "ERROR_CityTooLong" : "「市区町村」フィールドに入力した値が長すぎます。",
        "ERROR_StateTooLong" : "「都道府県/州」フィールドに入力した値が長すぎます。",
        "ERROR_CountryTooLong" : "「国/地域」フィールドに入力した値が長すぎます。",
        "ERROR_ZipCodeTooLong" : "「郵便番号」フィールドに入力した値が長すぎます。",
        "ERROR_EmailTooLong" : "E メール・フィールドに入力した値が長すぎます。",
        "ERROR_PhoneTooLong" : "「電話番号」フィールドに入力した値が長すぎます。",
        "ERROR_FaxTooLong" : "「FAX」フィールドに入力した値が長すぎます。",
        "ERROR_RecipientEmpty" : "配送先フィールドを空にすることはできません。",
        "ERROR_LastNameEmpty" : "姓フィールドを空にすることはできません。",
        "ERROR_MiddleNameEmpty" : "ミドルネーム・フィールドを空にすることはできません。",
        "ERROR_AddressEmpty" : "番地フィールドを空にすることはできません。",
        "ERROR_CityEmpty" : "市区町村フィールドを空にすることはできません。",
        "ERROR_StateEmpty" : "都道府県/州フィールドを空にすることはできません。",
        "ERROR_CountryEmpty" : "国/地域フィールドを空にすることはできません。",
        "ERROR_ZipCodeEmpty" : "郵便番号フィールドを空にすることはできません。",
        "ERROR_EmailEmpty" : "E メール・アドレス・フィールドを空にすることはできません。",
        "ERROR_FirstNameEmpty" : "名フィールドを空にすることはできません。",
        "ERROR_PhonenumberEmpty" : "電話番号フィールドを空にすることはできません。",
        "ERROR_PhoneEmpty" : "電話番号フィールドを空にすることはできません。",
        "ERROR_FaxEmpty" : "FAX フィールドを空にすることはできません。",
        "ERROR_INVALIDEMAILFORMAT" : "入力した E メールの形式が無効です。",
        "ERROR_INVALIDPHONE" : "入力した電話番号の形式が無効です。",
        "PWDREENTER_DO_NOT_MATCH" : "入力されたパスワードが一致しません。",
        "ERROR_SpecifyYear" : "年が指定されていません。 この情報の機密性を保持したい場合は、誕生日の値を指定しないでください。",
        "ERROR_SpecifyMonth" : "月が指定されていません。 この情報の機密性を保持したい場合は、誕生日の値を指定しないでください。",
        "ERROR_SpecifyDate" : "日が指定されていません。 この情報の機密性を保持したい場合は、誕生日の値を指定しないでください。",
        "ERROR_InvalidDate1" : "選択した月に関するこの日付が無効です。",
        "ERROR_InvalidDate2" : "入力した誕生日が無効です。",
        "ERROR_DEFAULTADDRESS" : "住所を削除できません。 住所録には、少なくとも 1 つの住所が含まれている必要があります。",
        "INVALID_EXPIRY_DATE" : "有効期限の日付が無効です。",
        "ERROR_LogonIdEmpty" : "ログオン ID フィールドを空にすることはできません。",
        "ERROR_PasswordEmpty" : "パスワード・フィールドを空にすることはできません。",
        "ERROR_VerifyPasswordEmpty" : "パスワードの確認フィールドを空にすることはできません。",
        "AGE_WARNING_ALERT" : "あなたはまだ 13 歳になっていません。先へ進む前に、子供向けのプライバシー・ポリシーを読んでください。",
        "ERROR_DefaultOrgRegistration" : "「デフォルトの組織」が無効な組織名です。 別の名前を選択してください。",
        
        
        "ERROR_OrgNameEmpty" : "組織名フィールドを空にすることはできません。",
        "ERROR_OrgNameTooLong" : "組織名フィールドに入力した値が長すぎます。",
        "Logon_WaitingForApproval" : "登録要求を受け取りました。  アカウントは、承認待ちです。 承認されるまで、ログオンできません。",
        "Logon_RegistrationRequired" : "ゲスト・ユーザーにはカタログのブラウズに制限があります。 登録またはログインして、ストアの全体にアクセスできるようにしてください。",
        "ERROR_OrganizationDescription" :"「組織の説明」フィールドに入力した値が長すぎます。",
        "ERROR_BusinessCategoryTooLong" :"「業種」フィールドに入力した値が長すぎます。",
        "ERROR_SelectOrganizationTypeEmpty" :"組織タイプを選択してください。",
        "ERROR_ParentOrgNameEmpty" :"作成したい新規組織の有効な親組織を検索して選択してください。",
        
        
        "ERROR_ADD2CART_BROWSE_ONLY" : "ブラウズ専用モードの場合、商品をショッピング・カートに追加することはできません。",
        
        
        "ERROR_SL_RESOLVED_SKU" : "選択が不完全です。 各属性に値を選択してください。",
        "ERROR_SL_EMPTY_SL_NAME" : "新規要求リストの名前を指定してください。",
        "ERROR_SL_LIST_NOT_CHOSEN" : "要求リストを選択してください。",
        "ERROR_GLOBALLOGIN_BUYER_SEARCH" : "検索の実行中にエラーが発生しました",
        "GLOBAL_LOGIN_NO_USERS_FOUND" : "ユーザーが見つかりません",
        
        "ORG_ROLES_UPDATED" : "組織の役割は正常に更新されました。",
        "ORG_ROLES_UPDATE_NO_CHNAGE" : "組織の役割に対して更新は行われません。",
        "APPROVAL_MEMBER_GROUP_UPDATED" : "承認メンバー・グループが正常に更新されました。",
        "ORG_ENTITY_CREATED_UPDATING_ROLES" : "組織が正常に作成されました。 組織の役割を更新中です。",
        "ORG_SUMMARY_UPDATED" : "組織の詳細情報が正常に更新されました。",

        
        "CSR_NO_SEARCH_CRITERIA" : "検索基準が入力されていません。 少なくとも 1 つの検索基準を入力してください。",
        "CSR_SUCCESS_CUSTOMER_ACCOUNT_ACCESS" : "顧客アカウントに正常にアクセスしました。",
        "SUCCESS_ORDER_UNLOCK" : "オーダーが正常にロック解除されました。",
        "SUCCESS_ORDER_LOCK" : "オーダーが正常にロックされました。",
        "SUCCESS_ORDER_TAKE_OVER" : "ロックが正常に引き継がれました。",
        "CUSTOMER_ACCOUNT_ENABLE_SUCCESS" : "顧客アカウントが正常に使用可能になりました。",
        "CUSTOMER_ACCOUNT_DISABLE_SUCCESS" : "顧客アカウントが正常に使用不可になりました。",
        "DISABLE_CUSTOMER_ACCOUNT" : "顧客アカウントを使用不可にする",
        "ENABLE_CUSTOMER_ACCOUNT" : "顧客アカウントを使用可能にする",
        "RESET_PASSWORD_SUCCESS" : "顧客のパスワードが正常に再設定されました。",
        "ORDER_CANCEL_SUCCESS" : "オーダーが正常にキャンセルされました。",
        "CSR_SUCCESS_NEW_GUEST_USER_CREATION" : "新規ゲスト顧客が正常に作成されました。",
        "CSR_SUCCESS_NEW_REGISTERED_USER_CREATION" : "新規登録済み顧客が正常に作成されました。",
        "CSR_PASSWORD_EMPTY" : "CSR パスワード・フィールドが空です。",
        "ERROR_RESET_PASSWORD_ACCESS_ACCOUNT_TO_RESET" : "新規登録済み顧客のパスワードの再設定が失敗しました。 顧客アカウントにアクセスしてパスワードを再設定してください。",
        "PLEASE_SELECT" :"選択してください",
        "CSR_SESSION_TERMINATE_WARNING_MESSAGE" : "顧客 \"{0}\" の現行セッションが終了します。 「はい」をクリックしてセッションを終了するか、「いいえ」をクリックして現行セッションを続行してください。",
        "GUEST" : "ゲスト",
        "CSR_PASSWORD_EMPTY_MESSAGE" : "続行するには、パスワードを入力してください。",
        "_ERR_PASSWORD_FAILED" :"試行されたパスワードが正しくありません。 もう一度やり直してください。",
        "ORDERS_SEARCH_BILLING_OPTION" : "請求情報",
        "ORDERS_SEARCH_SHIPPING_OPTION" : "配送情報",
        "LOCK_CUSTOMER_ORDER_CSR" : "オーダーをロック",
        "UNLOCK_CUSTOMER_ORDER_CSR" : "オーダーのロックを解除",
        "ORDER_LOCKED_ERROR_MSG" :"カートまたはオーダー \"{0}\" はロックされています。 詳しくは、サービス担当者にお問い合わせください",
        "ADD_COMMENT_MESSAGE" :"オーダーに新規のコメントを追加するには、ここをクリックします。",
        "COMMENT_LENGTH_OUT_OF_RANGE" : "コメントは 3000 文字を超えてはなりません。",
        "EMPTY_COMMENT" : "オーダーに追加するコメントを入力してください。"
    }
};